import type { Theme } from '@mui/material';

export const styles = {
  listItem: { width: '100%' },

  statusIcon: (theme: Theme) => ({
    color: theme.colors.neutral[300],
    alignItems: 'center',
    height: '1.5rem',
  }),

  icon: {
    maxHeight: '1.5rem',
    width: 'auto',
    mr: 1,
    fontSize: '1.5rem',
  },

  dolly: {
    pl: 0.25,
    pr: 1,
    mr: 1,
    height: '80%',

    svg: {
      height: '100%',
      width: 'auto',
    },
  },
};
